import React from 'react';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate
} from '@azure/msal-react';
import {LogInTemplate} from '../../templates/LogInTemplate';
import LoggedInTemplate from '../../templates/LoggedInTemplate';
import Snackbar from '../../components/Snackbar';
import WeatherBroadcast from '../../views/WeatherBroadcast';
import {Home} from '../../views/Home';

const App = () => {
  return (
    <React.Fragment>
      <Snackbar />
      <AuthenticatedTemplate>
        <LoggedInTemplate>
          <Router>
            <Switch>
              <Route
                path='(/.+)+'
                render={props => (
                  <WeatherBroadcast
                    filepath={props.history.location.pathname.replace(
                      /^\//,
                      ''
                    )}
                  />
                )}
              />
              <Route path='/'>
                <Home />
              </Route>
            </Switch>
          </Router>
        </LoggedInTemplate>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LogInTemplate />
      </UnauthenticatedTemplate>
    </React.Fragment>
  );
};

export default App;
